import React, { useState } from 'react';
import axios from 'axios';
import { utmPayload } from '../lib/tracking';
import { toast } from '../hooks/use-toast';

import WeddingsHero from '../components/weddings/WeddingsHero';
import WeddingsWhyChoose from '../components/weddings/WeddingsWhyChoose';
import WeddingsPackages from '../components/weddings/WeddingsPackages';
import WeddingsParallax from '../components/weddings/WeddingsParallax';
import WeddingsForm from '../components/weddings/WeddingsForm';
import WeddingsContact from '../components/weddings/WeddingsContact';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const INITIAL_FORM = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  weddingDate: '',
  guestCount: '',
  message: '',
  referralCode: '',
};

const Weddings = () => {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await axios.post(`${API}/weddings/book`, { ...formData, ...utmPayload() });
      if (response.data.success) {
        toast({
          title: '🎉 Wedding Booking Confirmed!',
          description:
            "We've sent your FREE Wedding Planner PDF to your email. We'll contact you soon to discuss your special day!",
        });
        setFormData(INITIAL_FORM);
      }
    } catch (error) {
      toast({
        title: 'Booking Failed',
        description: error.response?.data?.detail || 'Something went wrong. Please try again.',
        variant: 'destructive',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <WeddingsHero />
      <WeddingsWhyChoose />
      <WeddingsPackages />
      <WeddingsParallax />
      <WeddingsForm
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
      <WeddingsContact />
    </div>
  );
};

export default Weddings;
